import { render, staticRenderFns } from "./SmsVerificationModal.vue?vue&type=template&id=b72ec744&scoped=true&"
import script from "./SmsVerificationModal.vue?vue&type=script&lang=js&"
export * from "./SmsVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./SmsVerificationModal.vue?vue&type=style&index=0&id=b72ec744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ec744",
  null
  
)

export default component.exports